// extracted by mini-css-extract-plugin
export var error = "InputBase-module--error--55f57";
export var fullWidth = "InputBase-module--full-width--d3e8b";
export var input = "InputBase-module--input--0c4f2";
export var multiline = "InputBase-module--multiline--9e47d";
export var rightIcon = "InputBase-module--rightIcon--58018";
export var root = "InputBase-module--root--3bd2f";